/**
 * First visible wave gets 0, 1, 2… (capped). Cards that appear later get 0
 * so a newly completed job doesn't wait behind the opening choreography.
 *
 * Cap must match `PANEL_STAGGER_MAX_INDEX` in job-activity-panel-classes.ts.
 */
export const TASK_CARD_STAGGER_MAX_INDEX = 8;

export function assignEnterStaggerWave(
  assigned: Map<string, number>,
  orderedIds: readonly string[],
): void {
  if (orderedIds.length === 0) return;
  const isFirstWave = assigned.size === 0;
  for (const [i, id] of orderedIds.entries()) {
    if (assigned.has(id)) continue;
    assigned.set(id, isFirstWave ? Math.min(i, TASK_CARD_STAGGER_MAX_INDEX) : 0);
  }
}
